import { AbstractControl, FormControl } from '@angular/forms';

import { MonoTypeOperatorFunction } from 'rxjs';
import { observableInterval, observableMerge, rx } from '@shared/rx';
import { ENgFormStatus } from '@shared/types/enums';

/**
 * Temporary async validator fix until
 * https://github.com/angular/angular/issues/13200 and
 * https://github.com/angular/angular/issues/14542 are addressed.
 *
 * This problem has been already fixed in Angular 11:
 * https://github.com/angular/angular/commit/d9fea857db0638149f200ca86c7852c01c9787f4
 * TODO: remove this operator after update on Angular 11. It behaves in such way out of the box.
 *
 * Takes an optional interval as the second parameter which is the period
 * in milliseconds at which the form status will be checked. Default 250ms.
 */
export const fixFormStatus: (
  control: AbstractControl,
  interval?: number,
  /* eslint-disable */
) => MonoTypeOperatorFunction<string> =
  (control: FormControl, ms = 250) =>
  (source$: any) => {
    if (!control.asyncValidator) return source$;

    return observableMerge(
      source$,
      observableInterval(ms).pipe(
        rx.map(() => control.status),
        rx.takeWhile((status) => status === ENgFormStatus.Pending, true),
        rx.last(),
      ),
    ).pipe(rx.distinctUntilChanged());
  };
